import React, { useMemo, useState } from "react";

const API = "https://live-evo.com/api";

const NEON_CYAN = "#00f2ff";
const BG = "#020b14";
const CARD = "#051626";
const CARD_2 = "#031220";
const BORDER = "#1a2b3c";
const TEXT = "#ffffff";
const SUBTEXT = "#7f93a8";
const PLACEHOLDER = "#5b6c7d";

function AdminNotificationsWebPage() {
  const [sendMode, setSendMode] = useState("all");

  const [receiverEmail, setReceiverEmail] = useState("");

  const [category, setCategory] = useState("EVO");

  const [selectedPresetLabel, setSelectedPresetLabel] =
    useState("Choisir un modèle");

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const [sending, setSending] = useState(false);

  const [categoryModalVisible, setCategoryModalVisible] =
    useState(false);

  const [presetModalVisible, setPresetModalVisible] =
    useState(false);

  const categories = useMemo(
    () => [
      "EVO",
      "Saison EVO",
      "Challenge EVO",
      "LIVE",
      "Créateurs",
      "Vidéos & publications",
      "Stories",
      "Sécurité",
      "Modération",
      "Compte",
      "Portefeuille & paiements",
      "Maintenance",
      "Nouveautés",
      "Promotion & visibilité",
      "Communauté"
    ],
    []
  );

  const presets = [
    // ===== EVO =====
    {
      id: "evo_1",
      label: "Bienvenue EVO",
      category: "EVO",
      title: "👋 Bienvenue sur EVO LIVE",
      message:
        "Bienvenue sur EVO LIVE. Découvre les fonctionnalités de la plateforme et profite pleinement de ton expérience."
    },
    {
      id: "evo_2",
      label: "Information importante",
      category: "EVO",
      title: "ℹ️ Information EVO",
      message:
        "Une information importante concernant EVO LIVE est disponible."
    },
    {
      id: "evo_3",
      label: "Annonce EVO",
      category: "EVO",
      title: "📣 Annonce EVO LIVE",
      message:
        "Une nouvelle annonce EVO LIVE vient d’être publiée."
    },
    {
      id: "evo_4",
      label: "Merci à la communauté",
      category: "EVO",
      title: "💙 Merci la communauté EVO",
      message:
        "Merci de faire grandir EVO LIVE avec nous et de participer chaque jour à la communauté."
    },

    // ===== SAISON EVO =====
    {
      id: "season_1",
      label: "Ouverture Saison EVO",
      category: "Saison EVO",
      title: "🏆 La Saison EVO est ouverte",
      message:
        "La nouvelle Saison EVO est maintenant ouverte. Participe, gagne des XP et progresse jusqu’au rang Champion EVO."
    },
    {
      id: "season_2",
      label: "Saison en cours",
      category: "Saison EVO",
      title: "⚡ La Saison EVO continue",
      message:
        "La Saison EVO est en cours. Continue à gagner des XP et à débloquer les paliers."
    },
    {
      id: "season_3",
      label: "Derniers jours",
      category: "Saison EVO",
      title: "⏳ Derniers jours de la Saison EVO",
      message:
        "La Saison EVO touche bientôt à sa fin. Profite des derniers jours pour progresser et atteindre tes objectifs."
    },
    {
      id: "season_4",
      label: "Fin de saison",
      category: "Saison EVO",
      title: "🏁 Fin de la Saison EVO",
      message:
        "La Saison EVO est maintenant terminée. Merci à tous les participants."
    },
    {
      id: "season_5",
      label: "Champion Saison EVO",
      category: "Saison EVO",
      title: "👑 Champion EVO",
      message:
        "Félicitations ! Tu as atteint le rang Champion EVO pendant cette saison."
    },

    // ===== CHALLENGE EVO =====
    {
      id: "challenge_1",
      label: "Challenge disponible",
      category: "Challenge EVO",
      title: "🎯 Challenge EVO disponible",
      message:
        "Un Challenge EVO est disponible. Participe et progresse pour débloquer de nouvelles récompenses."
    },
    {
      id: "challenge_2",
      label: "Nouveau palier atteint",
      category: "Challenge EVO",
      title: "✨ Nouveau palier EVO atteint",
      message:
        "Bravo ! Tu viens d’atteindre un nouveau palier dans le Challenge EVO."
    },
    {
      id: "challenge_3",
      label: "Récompense débloquée",
      category: "Challenge EVO",
      title: "🎁 Récompense EVO débloquée",
      message:
        "Une nouvelle récompense du Challenge EVO est maintenant disponible sur ton compte."
    },
    {
      id: "challenge_4",
      label: "Objectif 100 000 XP",
      category: "Challenge EVO",
      title: "🔥 Objectif Champion EVO",
      message:
        "Continue ta progression vers les 100 000 XP et le rang Champion EVO."
    },

    // ===== LIVE =====
    {
      id: "live_1",
      label: "Nouveauté LIVE",
      category: "LIVE",
      title: "🔴 Nouveauté LIVE",
      message:
        "Une nouvelle fonctionnalité est disponible pour tes LIVE sur EVO."
    },
    {
      id: "live_2",
      label: "LIVE mis en avant",
      category: "LIVE",
      title: "🚀 Ton LIVE est mis en avant",
      message:
        "Ton LIVE bénéficie actuellement d’une mise en avant sur EVO LIVE."
    },
    {
      id: "live_3",
      label: "Rappel règles LIVE",
      category: "LIVE",
      title: "🛡️ Rappel des règles LIVE",
      message:
        "Pense à respecter les règles de la communauté pendant tes diffusions LIVE."
    },
    {
      id: "live_4",
      label: "Fonction LIVE disponible",
      category: "LIVE",
      title: "🎥 Fonction LIVE disponible",
      message:
        "Une nouvelle option est maintenant disponible dans tes paramètres LIVE."
    },

    // ===== CRÉATEURS =====
    {
      id: "creator_1",
      label: "Félicitations créateur",
      category: "Créateurs",
      title: "🌟 Bravo pour ta progression",
      message:
        "Ton activité de créateur progresse sur EVO LIVE. Continue comme ça."
    },
    {
      id: "creator_2",
      label: "Conseil créateur",
      category: "Créateurs",
      title: "💡 Conseil créateur EVO",
      message:
        "Publie régulièrement et interagis avec ta communauté pour développer ta visibilité."
    },
    {
      id: "creator_3",
      label: "Mise en avant créateur",
      category: "Créateurs",
      title: "✨ Créateur mis en avant",
      message:
        "Ton profil bénéficie actuellement d’une mise en avant sur EVO LIVE."
    },

    // ===== VIDÉOS & PUBLICATIONS =====
    {
      id: "post_1",
      label: "Publication mise en avant",
      category: "Vidéos & publications",
      title: "📈 Publication mise en avant",
      message:
        "Une de tes publications bénéficie d’une mise en avant sur EVO LIVE."
    },
    {
      id: "post_2",
      label: "Conseil publication",
      category: "Vidéos & publications",
      title: "🎬 Conseil publication EVO",
      message:
        "Un titre clair et une publication régulière peuvent aider ton contenu à toucher davantage de personnes."
    },
    {
      id: "post_3",
      label: "Publication retirée",
      category: "Vidéos & publications",
      title: "⚠️ Information concernant une publication",
      message:
        "Une de tes publications a fait l’objet d’une action de modération. Consulte les informations disponibles dans ton compte."
    },

    // ===== STORIES =====
    {
      id: "story_1",
      label: "Nouvelle fonction Story",
      category: "Stories",
      title: "📱 Nouveauté Stories EVO",
      message:
        "Une nouvelle fonctionnalité est maintenant disponible pour les Stories EVO."
    },
    {
      id: "story_2",
      label: "Conseil Story",
      category: "Stories",
      title: "✨ Partage une Story",
      message:
        "Partage un moment avec ta communauté grâce aux Stories EVO."
    },

    // ===== SÉCURITÉ =====
    {
      id: "security_1",
      label: "Alerte sécurité",
      category: "Sécurité",
      title: "🔐 Alerte sécurité EVO",
      message:
        "Une activité importante liée à la sécurité de ton compte a été détectée. Vérifie les informations de ton compte."
    },
    {
      id: "security_2",
      label: "Conseil sécurité",
      category: "Sécurité",
      title: "🛡️ Conseil sécurité EVO",
      message:
        "Ne partage jamais ton mot de passe ni tes informations de connexion avec une autre personne."
    },
    {
      id: "security_3",
      label: "Vérification requise",
      category: "Sécurité",
      title: "✅ Vérification requise",
      message:
        "Une vérification de ton compte est nécessaire pour continuer certaines opérations."
    },

    // ===== MODÉRATION =====
    {
      id: "moderation_1",
      label: "Premier avertissement",
      category: "Modération",
      title: "⚠️ Avertissement EVO",
      message:
        "Merci de respecter les règles de la communauté EVO LIVE."
    },
    {
      id: "moderation_2",
      label: "Contenu signalé",
      category: "Modération",
      title: "🚩 Contenu signalé",
      message:
        "Un contenu associé à ton compte a été signalé et peut faire l’objet d’une vérification."
    },
    {
      id: "moderation_3",
      label: "Action de modération",
      category: "Modération",
      title: "🛡️ Action de modération",
      message:
        "Une action de modération a été appliquée à ton compte ou à l’un de tes contenus."
    },
    {
      id: "moderation_4",
      label: "Signalement traité",
      category: "Modération",
      title: "✅ Signalement traité",
      message:
        "Ton signalement a été examiné par l’équipe EVO."
    },

    // ===== COMPTE =====
    {
      id: "account_1",
      label: "Profil mis à jour",
      category: "Compte",
      title: "⚙️ Profil mis à jour",
      message:
        "Les informations de ton profil ont été mises à jour avec succès."
    },
    {
      id: "account_2",
      label: "Compte vérifié",
      category: "Compte",
      title: "✅ Compte vérifié",
      message:
        "La vérification de ton compte EVO a été effectuée avec succès."
    },
    {
      id: "account_3",
      label: "Action requise",
      category: "Compte",
      title: "📌 Action requise sur ton compte",
      message:
        "Une action est nécessaire sur ton compte EVO. Consulte ton espace pour plus d’informations."
    },
    {
      id: "account_4",
      label: "Compte entreprise activé",
      category: "Compte",
      title: "🏢 Compte entreprise activé",
      message:
        "Ton compte est maintenant configuré en mode entreprise."
    },

    // ===== PORTEFEUILLE & PAIEMENTS =====
    {
      id: "wallet_1",
      label: "Paiement confirmé",
      category: "Portefeuille & paiements",
      title: "💳 Paiement confirmé",
      message:
        "Ton paiement EVO a été confirmé avec succès."
    },
    {
      id: "wallet_2",
      label: "Retrait reçu",
      category: "Portefeuille & paiements",
      title: "💶 Demande de retrait reçue",
      message:
        "Ta demande de retrait a bien été reçue et sera traitée selon les conditions EVO."
    },
    {
      id: "wallet_3",
      label: "Retrait validé",
      category: "Portefeuille & paiements",
      title: "✅ Retrait validé",
      message:
        "Ta demande de retrait EVO a été validée."
    },
    {
      id: "wallet_4",
      label: "Retrait refusé",
      category: "Portefeuille & paiements",
      title: "❌ Retrait non validé",
      message:
        "Ta demande de retrait n’a pas pu être validée. Consulte ton espace pour plus d’informations."
    },

    // ===== MAINTENANCE =====
    {
      id: "maintenance_1",
      label: "Maintenance programmée",
      category: "Maintenance",
      title: "🛠️ Maintenance EVO programmée",
      message:
        "Une maintenance EVO LIVE est programmée prochainement. Certaines fonctionnalités pourront être temporairement indisponibles."
    },
    {
      id: "maintenance_2",
      label: "Maintenance en cours",
      category: "Maintenance",
      title: "⚙️ Maintenance EVO en cours",
      message:
        "Une maintenance est actuellement en cours sur EVO LIVE. Merci de ta patience."
    },
    {
      id: "maintenance_3",
      label: "Maintenance terminée",
      category: "Maintenance",
      title: "✅ Maintenance terminée",
      message:
        "La maintenance EVO LIVE est terminée. Les services sont de nouveau disponibles."
    },
    {
      id: "maintenance_4",
      label: "Incident technique",
      category: "Maintenance",
      title: "⚠️ Incident technique EVO",
      message:
        "Nous rencontrons actuellement un incident technique sur certains services EVO LIVE."
    },

    // ===== NOUVEAUTÉS =====
    {
      id: "news_1",
      label: "Nouvelle fonctionnalité",
      category: "Nouveautés",
      title: "🚀 Nouvelle fonctionnalité EVO",
      message:
        "Une nouvelle fonctionnalité vient d’arriver sur EVO LIVE. Découvre-la dès maintenant."
    },
    {
      id: "news_2",
      label: "Mise à jour disponible",
      category: "Nouveautés",
      title: "📲 Mise à jour EVO disponible",
      message:
        "Une nouvelle version d’EVO LIVE est disponible avec des améliorations et de nouvelles fonctionnalités."
    },
    {
      id: "news_3",
      label: "Amélioration EVO",
      category: "Nouveautés",
      title: "✨ EVO LIVE s’améliore",
      message:
        "De nouvelles améliorations viennent d’être déployées sur EVO LIVE."
    },

    // ===== PROMOTION & VISIBILITÉ =====
    {
      id: "promo_1",
      label: "Booster une vidéo",
      category: "Promotion & visibilité",
      title: "📢 Booster ta vidéo",
      message:
        "Augmente la visibilité de ta vidéo grâce aux outils de promotion EVO."
    },
    {
      id: "promo_2",
      label: "Boost actif",
      category: "Promotion & visibilité",
      title: "🚀 Ton boost est actif",
      message:
        "Ton boost de visibilité EVO est maintenant actif."
    },
    {
      id: "promo_3",
      label: "Mise en avant profil",
      category: "Promotion & visibilité",
      title: "🌟 Profil mis en avant",
      message:
        "Ton profil bénéficie actuellement d’une mise en avant sur EVO LIVE."
    },
    {
      id: "promo_4",
      label: "Mise en avant LIVE",
      category: "Promotion & visibilité",
      title: "🔴 LIVE mis en avant",
      message:
        "Ton LIVE bénéficie actuellement d’une visibilité renforcée."
    },

    // ===== COMMUNAUTÉ =====
    {
      id: "community_1",
      label: "Message communauté",
      category: "Communauté",
      title: "💬 Message à la communauté EVO",
      message:
        "Un nouveau message est disponible pour toute la communauté EVO LIVE."
    },
    {
      id: "community_2",
      label: "Événement communautaire",
      category: "Communauté",
      title: "🎉 Événement EVO",
      message:
        "Un nouvel événement communautaire arrive sur EVO LIVE."
    },
    {
      id: "community_3",
      label: "Merci communauté",
      category: "Communauté",
      title: "💙 Merci à tous",
      message:
        "Merci à toute la communauté EVO LIVE pour votre participation et votre soutien."
    }
  ];

  const presetsByCategory = useMemo(() => {
    return presets.filter(
      (preset) => preset.category === category
    );
  }, [category]);

  const handleApplyPreset = (preset) => {
    setCategory(preset.category);
    setSelectedPresetLabel(preset.label);
    setTitle(preset.title);
    setMessage(preset.message);

    setPresetModalVisible(false);
  };

  const handleSelectCategory = (item) => {
    setCategory(item);

    setSelectedPresetLabel("Choisir un modèle");

    setTitle("");
    setMessage("");

    setCategoryModalVisible(false);
  };

  const handleSend = async () => {
    const cleanTitle = title.trim();
    const cleanMessage = message.trim();
    const cleanEmail = receiverEmail.trim();

    if (
      sendMode === "single" &&
      !cleanEmail
    ) {
      alert("Tu dois entrer un email.");
      return;
    }

    if (!cleanTitle || !cleanMessage) {
      alert("Titre et message obligatoires.");
      return;
    }

    try {
      setSending(true);

      const res = await fetch(
        `${API}/admin/send-notification`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json"
          },
          body: JSON.stringify({
            mode: sendMode,
            receiver_email:
              sendMode === "single"
                ? cleanEmail
                : null,
            category,
            title: cleanTitle,
            message: cleanMessage,
            type: "system"
          })
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(
          data.error || "Erreur"
        );
      }

      alert(
        sendMode === "all"
          ? "Notification envoyée à tous."
          : "Notification envoyée."
      );

      setTitle("");
      setMessage("");

      setSelectedPresetLabel(
        "Choisir un modèle"
      );

      if (sendMode === "single") {
        setReceiverEmail("");
      }
    } catch (err) {
      console.log(err);

      alert(
        "Impossible d'envoyer la notification."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: BG,
        color: TEXT
      }}
    >
      <div
        style={{
          height: 90,
          paddingTop: 35,
          paddingLeft: 15,
          paddingRight: 15,
          background: CARD_2,
          borderBottom:
            `1px solid ${BORDER}`,
          display: "flex",
          alignItems: "center",
          justifyContent:
            "space-between"
        }}
      >
        <button
          onClick={() => {
            window.location.href =
              "/admin";
          }}
          style={{
            width: 50,
            background: "transparent",
            border: "none",
            color: NEON_CYAN,
            fontSize: 30,
            cursor: "pointer"
          }}
        >
          ‹
        </button>

        <div
          style={{
            color: TEXT,
            fontSize: 15,
            fontWeight: "800",
            letterSpacing: 1
          }}
        >
          NOTIFICATIONS ADMIN
        </div>

        <div style={{ width: 50 }} />
      </div>

      <div
        style={{
          maxWidth: 1000,
          margin: "0 auto",
          padding: 14,
          paddingBottom: 120
        }}
      >
        <div style={heroCard}>
          <div style={heroTitle}>
            Envoyer une notification
          </div>

          <div style={heroDesc}>
            Envoie une notification système EVO à tous les comptes ou à un utilisateur précis.
          </div>
        </div>

        <div style={section}>
          <div style={sectionTitle}>
            DESTINATAIRE
          </div>

          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap"
            }}
          >
            <button
              onClick={() =>
                setSendMode("all")
              }
              style={{
                ...modeBtn,
                border:
                  sendMode === "all"
                    ? `1px solid ${NEON_CYAN}`
                    : `1px solid ${BORDER}`,
                color:
                  sendMode === "all"
                    ? NEON_CYAN
                    : SUBTEXT
              }}
            >
              Tous les comptes
            </button>

            <button
              onClick={() =>
                setSendMode("single")
              }
              style={{
                ...modeBtn,
                border:
                  sendMode === "single"
                    ? `1px solid ${NEON_CYAN}`
                    : `1px solid ${BORDER}`,
                color:
                  sendMode === "single"
                    ? NEON_CYAN
                    : SUBTEXT
              }}
            >
              Compte précis
            </button>
          </div>

          {sendMode === "single" && (
            <div style={{ marginTop: 12 }}>
              <div style={label}>
                Email destinataire
              </div>

              <input
                value={receiverEmail}
                onChange={(e) =>
                  setReceiverEmail(
                    e.target.value
                  )
                }
                placeholder="exemple@evo-live.com"
                style={input}
              />
            </div>
          )}
        </div>

        <div style={section}>
          <div style={sectionTitle}>
            CONFIGURATION
          </div>

          <button
            onClick={() =>
              setCategoryModalVisible(true)
            }
            style={dropdownBtn}
          >
            <span>{category}</span>
            <span>▾</span>
          </button>

          <button
            onClick={() =>
              setPresetModalVisible(true)
            }
            style={{
              ...dropdownBtn,
              marginTop: 12
            }}
          >
            <span>
              {selectedPresetLabel}
            </span>
            <span>▾</span>
          </button>
        </div>

        <div style={section}>
          <div style={sectionTitle}>
            CONTENU
          </div>

          <div style={label}>Titre</div>

          <input
            value={title}
            onChange={(e) =>
              setTitle(e.target.value)
            }
            style={input}
          />

          <div
            style={{
              ...label,
              marginTop: 14
            }}
          >
            Message
          </div>

          <textarea
            value={message}
            onChange={(e) =>
              setMessage(e.target.value)
            }
            style={textarea}
          />
        </div>

        <div style={section}>
          <div style={sectionTitle}>
            APERÇU
          </div>

          <div style={previewCard}>
            <div
              style={{
                display: "flex",
                justifyContent:
                  "space-between",
                marginBottom: 10
              }}
            >
              <div
                style={{
                  color: NEON_CYAN,
                  fontSize: 12,
                  fontWeight: "800"
                }}
              >
                {category}
              </div>

              <div
                style={{
                  color: SUBTEXT,
                  fontSize: 11
                }}
              >
                SYSTEME
              </div>
            </div>

            <div
              style={{
                color: TEXT,
                fontSize: 15,
                fontWeight: "800",
                marginBottom: 8
              }}
            >
              {title ||
                "Titre notification"}
            </div>

            <div
              style={{
                color: SUBTEXT,
                lineHeight: "20px",
                fontSize: 13
              }}
            >
              {message ||
                "Le message apparaîtra ici."}
            </div>
          </div>
        </div>

        <button
          disabled={sending}
          onClick={handleSend}
          style={sendBtn}
        >
          {sending
            ? "ENVOI..."
            : sendMode === "all"
            ? "Envoyer à tous les comptes"
            : "Envoyer au compte"}
        </button>

        <button
          onClick={() => {
            window.location.href =
              "/admin";
          }}
          style={cancelBtn}
        >
          Retour panneau admin
        </button>
      </div>

      {categoryModalVisible && (
        <ModalBox
          title="Choisir une catégorie"
          onClose={() =>
            setCategoryModalVisible(false)
          }
        >
          {categories.map((item) => (
            <button
              key={item}
              onClick={() =>
                handleSelectCategory(item)
              }
              style={{
                ...modalOption,
                border:
                  category === item
                    ? `1px solid ${NEON_CYAN}`
                    : `1px solid ${BORDER}`
              }}
            >
              {item}
            </button>
          ))}
        </ModalBox>
      )}

      {presetModalVisible && (
        <ModalBox
          title="Choisir un modèle"
          onClose={() =>
            setPresetModalVisible(false)
          }
        >
          {presetsByCategory.map(
            (preset) => (
              <button
                key={preset.id}
                onClick={() =>
                  handleApplyPreset(
                    preset
                  )
                }
                style={presetOption}
              >
                <div
                  style={{
                    color: TEXT,
                    fontWeight: "800"
                  }}
                >
                  {preset.label}
                </div>

                <div
                  style={{
                    color: NEON_CYAN,
                    fontSize: 12,
                    marginTop: 4
                  }}
                >
                  {preset.category}
                </div>

                <div
                  style={{
                    color: SUBTEXT,
                    marginTop: 8,
                    fontSize: 12,
                    lineHeight: "18px"
                  }}
                >
                  {preset.message}
                </div>
              </button>
            )
          )}
        </ModalBox>
      )}
    </div>
  );
}

function ModalBox({
  title,
  children,
  onClose
}) {
  return (
    <div style={modalOverlay}>
      <div style={modalCard}>
        <div style={modalTitle}>
          {title}
        </div>

        <div>{children}</div>

        <button
          onClick={onClose}
          style={modalCloseBtn}
        >
          Fermer
        </button>
      </div>
    </div>
  );
}

const heroCard = {
  background: CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: 14,
  padding: 15,
  marginBottom: 14
};

const heroTitle = {
  color: TEXT,
  fontSize: 18,
  fontWeight: "800",
  marginBottom: 6
};

const heroDesc = {
  color: SUBTEXT,
  fontSize: 13,
  lineHeight: "20px"
};

const section = {
  background: CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: 14,
  padding: 15,
  marginBottom: 14
};

const sectionTitle = {
  color: NEON_CYAN,
  fontSize: 13,
  fontWeight: "800",
  marginBottom: 12
};

const modeBtn = {
  flex: 1,
  background: "#071a2a",
  borderRadius: 10,
  padding: 12,
  fontWeight: "700",
  cursor: "pointer"
};

const label = {
  color: TEXT,
  fontSize: 13,
  fontWeight: "700",
  marginBottom: 8
};

const input = {
  width: "100%",
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 10,
  padding: 12,
  color: TEXT
};

const textarea = {
  width: "100%",
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 10,
  padding: 12,
  color: TEXT,
  minHeight: 120
};

const dropdownBtn = {
  width: "100%",
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 10,
  padding: 14,
  color: TEXT,
  display: "flex",
  justifyContent: "space-between",
  cursor: "pointer"
};

const previewCard = {
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  padding: 14
};

const sendBtn = {
  width: "100%",
  background: NEON_CYAN,
  border: "none",
  borderRadius: 12,
  padding: 14,
  fontWeight: "900",
  cursor: "pointer",
  marginBottom: 12
};

const cancelBtn = {
  width: "100%",
  background: "transparent",
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  padding: 14,
  color: TEXT,
  fontWeight: "800",
  cursor: "pointer"
};

const modalOverlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.72)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 18,
  zIndex: 9999
};

const modalCard = {
  background: CARD,
  border: `1px solid ${BORDER}`,
  borderRadius: 16,
  padding: 16,
  width: "100%",
  maxWidth: 600
};

const modalTitle = {
  color: TEXT,
  fontSize: 17,
  fontWeight: "800",
  marginBottom: 12
};

const modalOption = {
  width: "100%",
  background: "#071a2a",
  borderRadius: 10,
  padding: 13,
  color: TEXT,
  marginBottom: 10,
  cursor: "pointer"
};

const presetOption = {
  width: "100%",
  background: "#071a2a",
  border: `1px solid ${BORDER}`,
  borderRadius: 12,
  padding: 13,
  marginBottom: 10,
  textAlign: "left",
  cursor: "pointer"
};

const modalCloseBtn = {
  width: "100%",
  background: NEON_CYAN,
  border: "none",
  borderRadius: 12,
  padding: 12,
  marginTop: 12,
  fontWeight: "900",
  cursor: "pointer"
};

export default AdminNotificationsWebPage;
